import axiosV1 from "@/plugins/axios/configV1";

export default {
    getAdvertisements(params = {}) {
        return axiosV1.get(`ads`, { params });
    },
    getAdvertisement(id = null) {
        return axiosV1.get(`ads/fetch/${id}`);
    },
    viewAdvertisement(id = null) {
        return axiosV1.get(`ads/view/${id}`);
    },
    addAdvertisement(payload = {}) {
        let formData = new FormData();
        for (const key in payload) {
            if (key === "product_ids") {
                formData.append(
                    key,
                    !!payload[key].length ? JSON.stringify(payload[key]) : null
                );
            } else {
                formData.append(key, payload[key] ? payload[key] : "");
            }
        }
        return axiosV1.post("ads", formData);
    },
    updateAdvertisement(id = null, payload = {}) {
        let formData = new FormData();
        for (const key in payload) {
            if (key === "product_ids") {
                formData.append(
                    key,
                    !!payload[key].length ? JSON.stringify(payload[key]) : null
                );
            } else {
                formData.append(key, payload[key] ? payload[key] : "");
            }
        }
        axiosV1.defaults.headers.common["Content-Type"] = "multipart/form-data";

        return axiosV1.post(`ads/update/${id}`, formData);
    },
    getParticipatingModels(params = {}) {
        return axiosV1.get(`ads/fetch/models`, { params });
    },
    mergeModels(payload) {
        payload = {
            ...payload,
            select_ids: !!payload.select_ids.length
                ? JSON.stringify(payload.select_ids)
                : null,
            product_ids: !!payload.product_ids.length
                ? JSON.stringify(payload.product_ids)
                : null,
        };
        return axiosV1.post(`ads/paginate/models`, { ...payload });
    },

    exportExcel(params) {
        return axiosV1.get(`ads/export`, { params });
    },
    deleteAdvertisement(id = null) {
        return axiosV1.post(`ads/delete/${id}`);
    },
    deleteAdvertisementAll(ids = {}) {
        return axiosV1.post(`ads/bulk/delete`, ids);
    },
    recoverAdvertisement(id = null) {
        return axiosV1.post(`ads/restore/${id}`);
    },
    recoverAdvertisementAll(ids = {}) {
        return axiosV1.post(`ads/bulk/recover`, ids);
    },
    destroyAdvertisement(id = null) {
        return axiosV1.post(`ads/delete/force/${id}`);
    },
    destroyAdvertisementAll(ids = {}) {
        return axiosV1.post(`ads/bulk/delete/force`, ids);
    },

    importAdvertisement(file = null) {
        let formData = new FormData();
        formData.append("file", file);
        axiosV1.defaults.headers.common["Content-Type"] = "multipart/form-data";
        return axiosV1.post(`ads/import`, formData);
    },

    // Categories
    getAdCategories(params = {}) {
        return axiosV1.get(`ads/categories/list`, { params });
    },
    addAdCategory(payload = {}) {
        return axiosV1.post(`ads/categories`, payload);
    },
    deleteAdCategory(id = null) {
        return axiosV1.post(`ads/categories/delete/${id}`);
    },
    deleteAdCategoryAffected(id = null) {
        return axiosV1.get(`ads/categories/delete-affected/${id}`);
    },
};
